import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CurrentsIntegrationsCreateForNro = lazy(() =>
  import("@scenes/CurrentsIntegration/CurrentsIntegrationCreateNRO").then((module) => ({
    default: module.CurrentsIntegrationCreateNRO,
  }))
);

export const integrationsCurrentsIntegrationsNewDestinationNRO: NavigationRoutingObject = {
  section: "partner-integrations",
  Component: CurrentsIntegrationsCreateForNro,
  componentFeatureFlippers: ["currents_integrations"],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("data-export-create-currents-new", "Create Data Export"),
  pageNameForTracking: () => "Create Data Export",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("currents-description-nav", "Create and manage your Currents connections"),
  icon: "nav-system-data-export",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("currents_integrations");
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/currents_integrations/:appGroupId",
};
